<template>
  <div>
    <div
      v-for="layer in map"
      :key="layer.title"
      class="px-1"
    >
      <div class="bus">
        <div class="bus-title">
          {{ layer.title }}
        </div>
        <div class="bus-caption">
          {{ layer.categ_str }}
        </div>
        <div
          class="bus-seats"
          :class="'bus-seats_' + layer.layout.reduce((a, b) => (b instanceof Array && a < b.length ? b.length : a), 0)"
        >
          <div class="bus-section">
            <span>FRENTE</span>
          </div>
          <table>
            <tr
              v-for="(row, r) in layer.layout"
              :key="r"
            >
              <td>{{ r + 1 }}</td>
              <template v-for="(seat, c) in row">
                <td
                  v-if="seat == 'P'"
                  :key="c"
                >
                  <span class="bus-path" />
                </td>
                <td
                  v-else
                  :class="'bus-seat bus-seat_' + seat.status"
                  @click="$emit('seat', seat.id)"
                  :key="c"
                >
                  <div v-if="seat.passenger">
                    <span class="bus-seat-tooltip">{{ seat.passenger.alt }}</span>
                    <span class="bus-seat-dot" />
                  </div>
                  <seat-icon :fill="seat.fill" />
                </td>
              </template>
              <td>{{ r + 1 }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeatIcon from '@/components/SeatIcon'

export default {
  components: { SeatIcon },

  name: 'Bus',

  props: ['map'],

  data () {
    return {}
  }
}
</script>
